import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteGate from "@/components/SiteGate";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import DhanGuidePage from "@/pages/DhanGuidePage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import AutoTrade from "@/pages/AutoTrade";
import ScalpTrade from "@/pages/ScalpTrade";
import ThetaFollower from "@/pages/ThetaFollower";
import QuantLab from "@/pages/QuantLab";
import ResetPassword from "@/pages/ResetPassword";
import EngineAlerts from "@/components/EngineAlerts";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth return synchronously, before normal routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/dhan-guide" element={<DhanGuidePage />} />
      <Route path="/admin/users" element={<AdminUsersPage />} />
      <Route path="/auto-trade" element={<AutoTrade />} />
      <Route path="/scalp-trade" element={<ScalpTrade />} />
      <Route path="/theta" element={<ThetaFollower />} />
      <Route path="/quant-lab" element={<QuantLab />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <SiteGate>
        <AuthProvider>
          <AppRouter />
          <EngineAlerts />
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </SiteGate>
    </BrowserRouter>
  );
}
